<template>
  <button data-test-id="base-button" type="button">
    <slot />
  </button>
</template>
